import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const RequireAuth = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div data-testid="auth-loading" className="min-h-screen bg-[#0B0A08] flex flex-col items-center justify-center gap-3">
        <div className="text-[#E8DCC4] text-2xl tracking-[0.35em] font-serif">OMR PERFUMER</div>
        <div className="text-[#8A857D] text-[11px] tracking-[0.3em] animate-pulse">LOADING · جارٍ التحميل</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/welcome" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
};
